import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  defaults: "2026-05-30",
  disable_session_recording: true,
  tracing_headers: [
    "boardblend.com",
    "www.boardblend.com",
    "local.boardblend.com",
    "localhost",
    "127.0.0.1",
  ],
});
